<script setup lang="ts">
import Skeleton from './Skeleton.vue'

withDefaults(
  defineProps<{
    rows?: number
    cols?: number
  }>(),
  { rows: 6, cols: 6 }
)

const widths = ['w-8', 'w-44', 'w-36', 'w-32', 'w-20', 'w-16', 'w-24']
</script>

<template>
  <div class="w-full">
    <!-- 👉 Header -->
    <div class="hidden lg:flex items-center gap-4 px-4 pb-3">
      <Skeleton v-for="i in cols" :key="`h-${i}`" class="h-3 w-16" />
    </div>

    <!-- 👉 Rows -->
    <div class="flex flex-col divide-y divide-[#eaeef5] rounded-xl bg-white px-4">
      <div
        v-for="r in rows"
        :key="`r-${r}`"
        class="flex flex-wrap items-center gap-4 py-5"
      >
        <Skeleton
          v-for="c in cols"
          :key="`c-${c}`"
          class="h-4"
          :class="widths[(c - 1) % widths.length]"
        />
      </div>
    </div>
  </div>
</template>
